<template>
  <section :id="id" :class="sectionClasses">
    <h2 v-if="sectionTitle">
      <span v-if="showSectionNumber" class="number">{{
        sectionNumber + '.'
      }}</span>
      {{ sectionTitle }}
    </h2>
    <ErrorList
      :errors="errors"
      :error-styling="{
        ul: {
          'list-style-type': 'none',
          'margin-top': '10px',
          'margin-left': 0,
        },
        li: {
          'margin-top': '5px',
          'font-weight': 'bold',
        },
      }"
    />
    <template v-if="enabled">
      <template v-if="showChangeLink">
        <button
          v-if="drawerOpen && showCloseLink"
          class="change"
          aria-expanded="true"
          @click="closeClicked"
        >
          Close
        </button>
        <button
          v-else-if="!drawerOpen"
          class="change"
          aria-expanded="false"
          @click="changeClicked"
        >
          {{ changeText }}
        </button>
      </template>
      <div v-show="!drawerOpen" class="checkout-section-summary">
        <slot name="collapsed"></slot>
      </div>
      <div v-show="drawerOpen" class="checkout-section-content">
        <slot name="expanded"></slot>
      </div>
    </template>
  </section>
</template>

<script>
import ErrorList from '#common/components/ErrorList.vue'

export default {
  name: 'CheckoutSection',
  components: { ErrorList },
  props: {
    showSectionNumber: {
      type: Boolean,
      required: false,
      default: true,
    },
    sectionTitle: {
      type: String,
      required: true,
    },
    sectionNumber: {
      type: Number,
      required: true,
    },
    showChangeLink: {
      type: Boolean,
      required: false,
      default: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    drawerOpen: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    errors: {
      type: Array,
      required: false,
      default: () => [],
    },
    classes: {
      type: Array,
      required: false,
      default: () => ['bordered-section'],
    },
    showCloseLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    changeText: {
      type: String,
      required: false,
      default: 'Change',
    },
  },
  emits: ['drawerClosed', 'drawerOpen'],
  computed: {
    sectionClasses() {
      let classes = this.classes
      if (this.enabled) {
        if (this.drawerOpen) {
          classes = [...classes, 'active', 'edit']
        } else {
          classes = [...classes, 'submitted']
        }
      }
      return classes
    },
  },
  methods: {
    closeClicked() {
      this.$emit('drawerClosed')
    },
    changeClicked() {
      this.$emit('drawerOpen')
    },
  },
}
</script>

<style scoped></style>
